import React from 'react'
import translate from 'App/i18n/translate'
import Translate from 'App/i18n'
import {Form, Field} from 'simple-react-form'
import Text from './Text'
import Button from 'orionsoft-parts/lib/components/Button'
import styles from './styles.css'
import autobind from 'autobind-decorator'
import {createUser} from 'meteor-apollo-accounts'
import TOS from './TOS'
// import Social from './Social'
import {gql, withApollo} from 'react-apollo'
import track from 'App/helpers/track'
import getQueryParam from 'orionsoft-parts/lib/helpers/getQueryParam'
import PropTypes from 'prop-types'
import contextUrl from '../../Root/contextUrl'
import {Link} from 'react-router'
import ReactGA from 'react-ga';
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import { withRouter } from "react-router"
import withMutation from 'react-apollo-decorators/lib/withMutation'

@withGraphQL(gql`
  query me {
    me {
      _id
      email
    }
  }
`)
@withApollo

@withRouter
@withMutation(gql`
  mutation welcomeEmail($userEmail: String) {
    welcomeEmail(userEmail: $userEmail) {
      success
    }
  }
`)
export default class Register extends React.Component {
  state = {}

  static propTypes = {
    setLoading: PropTypes.func,
    setError: PropTypes.func,
    onSuccess: PropTypes.func,
    isLoading: PropTypes.bool,
    client: PropTypes.object,
    me: PropTypes.object,
    welcomeEmail: PropTypes.func,
  }

  state = {
  }

  componentDidMount() {
    const email = getQueryParam('email')
    if (email) {
      this.setState({email: email})
    }
    this.setState({contextUrl: contextUrl});
    console.log("ContextURL", contextUrl)
  }

  @autobind
  async register() {
    var myReg= /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)\S{8,}$/
     
    if (!this.canRegister()) return
    if(myReg.test(this.state.password)===false){
      return this.props.setError(<Translate tr="auth.pages.passwordDoesntRequire" />)
    }
    if (this.state.password !== this.state.confirm) {
        return this.props.setError(<Translate tr="auth.pages.passwordDoesntMatch" />)
      }
    this.props.setLoading(true)
    this.props.setError(null)
    
    
    console.log("state:", this.state)

    ReactGA.event({
      category: "conversion",
      action: "conversion",
    });
    console.log("Conversion reportada");

    try {
      await createUser( this.state, this.props.client, this.state.contextUrl);
      this.props.onSuccess()
      track('register')
    } catch (e) {
      this.props.setError(<div>No fue posible crear la cuenta<br/> 
        <ul>
          {/* <li>Reinicia tu password <Link to="/forgot">aquí</Link></li> */}
          <li>Inicia sesión con token <Link to='/logintoken'>aquí</Link></li>
        </ul>
        </div>)
      this.props.setLoading(false)
      console.log(e);
    }
  }

  /*
  async canRegister() {
    try {
      await this.props.welcomeEmail({userEmail:this.state.email})
      this.setState({isReady: true})
      return this.state.contextUrl && this.state.email && this.state.password && this.state.confirm
    } catch (error) {
      this.setState({errorMessage: "No ha sido posible crear la cuenta"})
      this.props.setLoading(false)
    }    
  }
  */

  canRegister() {
    return this.state.contextUrl && this.state.email && this.state.password && this.state.confirm
  }

  renderButtons() {
    return (
      <div className={styles.buttonsContainer}>
        <Button
          disabled={!this.canRegister()}
          primary
          onClick={this.register}
          fullWidth
          loading={this.props.isLoading}
        >
          <Translate tr="auth.pages.register" />
        </Button>
      </div>
    )
  }


  renderRegisterInfo(){
      return ( 
              <div>
                <p><b>Bienvenido a tu plataforma de firma digital</b></p>
                <p className={styles.detailText}></p>
              </div>  )
  }

  render() {
    if(this.props.me){
      console.log("Hay me", this.props.usersData);
      this.props.router.push('/')
    } else {
      console.log("NO Hay me", this.props.me);
    }
    return ( 
      <div>
        { this.renderRegisterInfo() }
        {/* <Social {...this.props} /> */}
        <Form state={this.state} onChange={changes => this.setState(changes)} onSubmit={this.register}>
          <Field
            fieldName="email"
            type={Text}
            fieldType="email"
            placeholder={translate('auth.pages.email')}
          />
          <br />
          <Field
            fieldName="password"
            type={Text}
            fieldType="password"
            placeholder={translate('auth.pages.password')}
            minLength = '8'
          />
          <br />
          <Field
            fieldName="confirm"
            type={Text}
            fieldType="password"
            placeholder={translate('auth.pages.confirmPassword')}
            minLength = '8'
          />
        </Form>
        {this.renderButtons()}
        <br />
        <Translate tr="auth.pages.otherLinksInRegister" />
        <br />
        <TOS />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Auth/Register.js